document.addEventListener('DOMContentLoaded', () => {
  const BREAKPOINT = 989;
  const detailsItems = document.querySelectorAll('header-menu details');

  if (!detailsItems.length) return;

  const isDesktop = () => window.innerWidth >= BREAKPOINT;

  const updateSubmenu = (details, submenu) => {
    if (!isDesktop()) return;

    const parentRect = details.getBoundingClientRect();
    submenu.style.left = `${-parentRect.left}px`;
    submenu.style.width = '100vw';
  };

  detailsItems.forEach(details => {
    const submenu = details.querySelector('.header__submenu');
    if (!submenu) return;

    details.addEventListener('toggle', () => {
      if (details.open && isDesktop()) {
        requestAnimationFrame(() => updateSubmenu(details, submenu));
      }
    });
  });

  window.addEventListener('resize', () => {
    if (!isDesktop()) return;

    detailsItems.forEach(details => {
      const submenu = details.querySelector('.header__submenu');
      if (submenu) updateSubmenu(details, submenu);
    });
  });
});

document.addEventListener('DOMContentLoaded', function () {
  const drawer = document.getElementById('Details-menu-drawer-container');

  if (!drawer) return;

  drawer.addEventListener('toggle', function () {
    const subMenus = drawer.querySelectorAll('header-menu details');

    if (drawer.open) {
      // Open all submenus when hamburger opens
      subMenus.forEach(menu => {
        menu.setAttribute('open', true);
      });
    } else {
      // Close all submenus when hamburger closes
      subMenus.forEach(menu => {
        menu.removeAttribute('open');
      });
    }
  });
});


document.addEventListener('DOMContentLoaded', () => {
  /* ===============================
     OPEN / CLOSE PANEL (MULTIPLE)
  =============================== */
  const currencyPanel = document.getElementById('ft-currency');
  const closeBtn = currencyPanel?.querySelector('.ft-currency--close');
  const triggers = document.querySelectorAll('.t-currency');

  if (currencyPanel && triggers.length) {
    triggers.forEach(trigger => {
      trigger.addEventListener('click', e => {
        e.preventDefault();
        currencyPanel.classList.add('is-active');
      });
    });

    closeBtn?.addEventListener('click', () => {
      currencyPanel.classList.remove('is-active');
    });

    currencyPanel.addEventListener('click', e => {
      if (e.target === currencyPanel) {
        currencyPanel.classList.remove('is-active');
      }
    });
  }

  /* ===============================
     LANGUAGE → TEXT + FLAG (MULTIPLE)
  =============================== */
  const updateCurrencyUI = () => {
    const lang = document.documentElement.lang; // ja, en, it, en-US

    document.querySelectorAll('.t-currency').forEach(item => {
      const txt = item.querySelector('.t-currency--txt');
      const flag = item.querySelector('.t-currency--flag');

      if (!txt || !flag) return;

      flag.classList.remove('jpy', 'en', 'cn');

      if (lang.startsWith('en')) {
        txt.textContent = 'EN';
        flag.classList.add('en');
      } 
      else if (lang.startsWith('zh')) {
        txt.textContent = 'CN';
        flag.classList.add('cn');
      } 
      else {
        txt.textContent = 'JP';
        flag.classList.add('jpy');
      }
    });
  };

  // initial run
  updateCurrencyUI();

  // safety for Shopify dynamic reloads
  document.addEventListener('shopify:section:load', updateCurrencyUI);
});

document.addEventListener('DOMContentLoaded', () => {

  const wrappers = document.querySelectorAll('.mobile__currency');
  if (!wrappers.length) return;

  wrappers.forEach(wrapper => {

    /* ---------- LANGUAGE ---------- */
    const langToggle = wrapper.querySelector('.mobileLangToggle');
    const langList   = wrapper.querySelector('.mobileLangList');
    const langForm   = wrapper.querySelector('.MobileLanguageForm');
    const langInput  = langForm?.querySelector('input[name="language_code"]');
    const langTxt    = langToggle?.querySelector('.mobile__currency--lang--txt');
    const langFlag   = langToggle?.querySelector('.mobile__currency--lang--flag');

    /* ---------- COUNTRY / PRICE ---------- */
    const priceToggle = wrapper.querySelector('.mobilePriceToggle');
    const priceList   = wrapper.querySelector('.mobilePriceList');
    const priceForm   = wrapper.querySelector('.MobileCountryForm');
    const priceInput  = priceForm?.querySelector('input[name="country_code"]');
    const priceTxt    = priceToggle?.querySelector('.mobile__currency--price--txt');

    if (
      !langToggle || !langList || !langForm ||
      !priceToggle || !priceList || !priceForm
    ) return;

    /* ---------- LANGUAGE UI ---------- */
    const updateLangUI = (lang) => {
      if (!langFlag || !langTxt) return;

      langFlag.classList.remove('jpy', 'en', 'cn');

      if (lang.startsWith('en')) {
        langTxt.textContent = 'EN';
        langFlag.classList.add('en');
      } else if (lang.startsWith('zh')) {
        langTxt.textContent = 'CN';
        langFlag.classList.add('cn');
      } else {
        langTxt.textContent = 'JP';
        langFlag.classList.add('jpy');
      }
    };

    updateLangUI(document.documentElement.lang || langInput?.value || 'ja');

    /* ---------- TOGGLES ---------- */
    langToggle.addEventListener('click', e => {
      e.stopPropagation();

      langList.classList.toggle('is-open');
      langToggle.classList.toggle('is-open');

      priceList.classList.remove('is-open');
      priceToggle.classList.remove('is-open');
    });

    priceToggle.addEventListener('click', e => {
      e.stopPropagation();

      priceList.classList.toggle('is-open');
      priceToggle.classList.toggle('is-open');

      langList.classList.remove('is-open');
      langToggle.classList.remove('is-open');
    });

    /* ---------- LANGUAGE CHANGE ---------- */
    langList.querySelectorAll('a[data-value]').forEach(link => {
      link.addEventListener('click', e => {
        e.preventDefault();
        e.stopPropagation();

        const lang = link.dataset.value;
        if (!langInput) return;

        langInput.value = lang;
        updateLangUI(lang);

        langList.classList.remove('is-open');
        langToggle.classList.remove('is-open');

        langForm.submit();
      });
    });

    /* ---------- COUNTRY / PRICE CHANGE ---------- */
    priceList.querySelectorAll('a[data-value]').forEach(link => {
      link.addEventListener('click', e => {
        e.preventDefault();
        e.stopPropagation();

        const country = link.dataset.value;
        if (!priceInput || !priceTxt) return;

        priceInput.value = country;
        priceTxt.textContent = link.textContent.trim();

        priceList.classList.remove('is-open');
        priceToggle.classList.remove('is-open');

        priceForm.submit();
      });
    });

  });

  /* ---------- CLOSE WHEN CLICKING OUTSIDE (GLOBAL, ONCE) ---------- */
  document.addEventListener('click', e => {
    wrappers.forEach(wrapper => {
      if (!wrapper.contains(e.target)) {
        wrapper.querySelector('.mobileLangList')?.classList.remove('is-open');
        wrapper.querySelector('.mobilePriceList')?.classList.remove('is-open');
        wrapper.querySelector('.mobileLangToggle')?.classList.remove('is-open');
        wrapper.querySelector('.mobilePriceToggle')?.classList.remove('is-open');
      }
    });
  });

});

//show category sidebar
document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.facets-vertical .facets__summary[aria-expanded="false"]').forEach(summary => {
    summary.click();
  });
});


//photo model banner
document.addEventListener('DOMContentLoaded', () => {
  const BREAKPOINT = 750;

  document.querySelectorAll('.swiper-section').forEach(section => {
    const swiperEl = section.querySelector('.image-swiper');
    if (!swiperEl) return;

    let swiper = null;
    let isDesktop = window.innerWidth > BREAKPOINT;

    const initSwiper = () => {
      isDesktop = window.innerWidth > BREAKPOINT;

      swiper = new Swiper(swiperEl, {
        slidesPerView: isDesktop ? 1 : 'auto',
        spaceBetween: isDesktop ? 20 : 10,
        loop: false,
        allowTouchMove: true,
        autoplay: false,

        // ✅ allow taps inside video area
        noSwiping: true,
        noSwipingClass: 's-video',

        pagination: isDesktop
          ? {
              el: section.querySelector('.swiper-pagination'),
              clickable: true
            }
          : false,

        navigation: isDesktop
          ? {
              nextEl: section.querySelector('.swiper-button-next'),
              prevEl: section.querySelector('.swiper-button-prev')
            }
          : false,

        scrollbar: !isDesktop
          ? {
              el: section.querySelector('.swiper-scrollbar'),
              draggable: true
            }
          : false
      });

      // ▶️ Custom play / pause button
      swiperEl.querySelectorAll('.s-video--play').forEach(playBtn => {
        const slide = playBtn.closest('.swiper-slide'); // ✅ parent
        const video = slide?.querySelector('.s-video video');

        if (!video || !slide) return;

        playBtn.addEventListener('click', e => {
          e.preventDefault();
          e.stopPropagation(); // ⛔ stop swiper hijack on mobile

          if (video.paused) {
            video.play();
            slide.classList.add('s-play'); // ✅ moved here
            swiper.allowTouchMove = false;
          } else {
            video.pause();
            slide.classList.remove('s-play');
            swiper.allowTouchMove = true;
          }
        });

        video.addEventListener('pause', () => {
          slide.classList.remove('s-play');
          swiper.allowTouchMove = true;
        });

        video.addEventListener('ended', () => {
          slide.classList.remove('s-play');
          video.currentTime = 0;
          swiper.allowTouchMove = true;
        });
      });

      // ⛔ Stop videos on slide change
      swiper.on('slideChangeTransitionStart', () => {
        swiperEl.querySelectorAll('video').forEach(video => {
          video.pause();
          video.currentTime = 0;
        });

        swiperEl.querySelectorAll('.swiper-slide').forEach(slide => {
          slide.classList.remove('s-play');
        });

        swiper.allowTouchMove = true;
      });
    };

    initSwiper();

    window.addEventListener('resize', () => {
      const nowDesktop = window.innerWidth > BREAKPOINT;
      if (nowDesktop === isDesktop) return;

      swiper.destroy(true, true);
      swiper = null;
      initSwiper();
    });
  });
});


document.addEventListener('DOMContentLoaded', () => {
  const BREAKPOINT = 750;

  document.querySelectorAll('.swiper-products').forEach(section => {
    const swiperEl = section.querySelector('.product-swiper');
    if (!swiperEl) return;

    let swiper = null;
    let isDesktop = window.innerWidth > BREAKPOINT;

    const initSwiper = () => {
      isDesktop = window.innerWidth > BREAKPOINT;

      swiper = new Swiper(swiperEl, {
        slidesPerView: isDesktop ? 4 : 'auto',
        spaceBetween: isDesktop ? 20 : 15,

        loop: isDesktop,
        allowTouchMove: true,

        // ❗ DO NOT define autoplay on mobile at all
        ...(isDesktop && {
          autoplay: {
            delay: 5000,
            disableOnInteraction: false
          }
        }),

        pagination: isDesktop
          ? {
              el: section.querySelector('.swiper-pagination'),
              clickable: true
            }
          : false,

        navigation: isDesktop
          ? {
              nextEl: section.querySelector('.swiper-button-next'),
              prevEl: section.querySelector('.swiper-button-prev')
            }
          : false,

        // Mobile scrolling
        // freeMode: !isDesktop
        //   ? {
        //       enabled: true,
        //       momentum: true
        //     }
        //   : false,

        scrollbar: !isDesktop
          ? {
              el: section.querySelector('.swiper-scrollbar'),
              draggable: true
            }
          : false
      });

      // 🔥 HARD STOP autoplay if mobile
      if (!isDesktop && swiper.autoplay) {
        swiper.autoplay.stop();
      }
    };

    initSwiper();

    window.addEventListener('resize', () => {
      const nowDesktop = window.innerWidth > BREAKPOINT;
      if (nowDesktop === isDesktop) return;

      swiper.destroy(true, true);
      swiper = null;
      initSwiper();
    });
  });
});

document.addEventListener('DOMContentLoaded', () => {
  const BREAKPOINT = 750;

  document.querySelectorAll('.swiper-blog').forEach(section => {
    const swiperEl = section.querySelector('.blog-swiper');
    if (!swiperEl) return;

    let swiper = null;
    let isDesktop = window.innerWidth > BREAKPOINT;

    const initSwiper = () => {
      isDesktop = window.innerWidth > BREAKPOINT;

      const slideCount =
        swiperEl.querySelectorAll('.swiper-slide').length;

      const desktopSlidesPerView = 3;
      const enableDesktopFeatures =
        isDesktop && slideCount > desktopSlidesPerView;

      swiper = new Swiper(swiperEl, {
        slidesPerView: isDesktop ? desktopSlidesPerView : 'auto',
        spaceBetween: isDesktop ? 40 : 20,

        loop: enableDesktopFeatures,
        allowTouchMove: true,

        autoplay: enableDesktopFeatures
          ? {
              delay: 5000,
              disableOnInteraction: false
            }
          : false,

        pagination: enableDesktopFeatures
          ? {
              el: section.querySelector('.swiper-pagination'),
              clickable: true
            }
          : false,

        navigation: enableDesktopFeatures
          ? {
              nextEl: section.querySelector('.swiper-button-next'),
              prevEl: section.querySelector('.swiper-button-prev')
            }
          : false,

        scrollbar: !isDesktop
          ? {
              el: section.querySelector('.swiper-scrollbar'),
              draggable: true
            }
          : false
      });

      // 🔒 EXTRA SAFETY: hard-stop autoplay if disabled
      if (!enableDesktopFeatures && swiper.autoplay) {
        swiper.autoplay.stop();
      }
    };

    initSwiper();

    window.addEventListener('resize', () => {
      const nowDesktop = window.innerWidth > BREAKPOINT;
      if (nowDesktop === isDesktop) return;

      if (swiper) {
        swiper.destroy(true, true);
        swiper = null;
      }

      initSwiper();
    });
  });
});

document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.swiper-visual').forEach(section => {
    const swiperEl = section.querySelector('.visual-swiper');
    const playBtn = section.querySelector('.swiper-play');
    const progressCircle = section.querySelector('.swiper-play--progress circle');

    const paginationEl = section.querySelector('.swiper-pagination');
    const prevBtn = section.querySelector('.swiper-button-prev');
    const nextBtn = section.querySelector('.swiper-button-next');

    if (!swiperEl || !playBtn || !progressCircle) return;

    const RADIUS = 24;
    const CIRCUMFERENCE = 2 * Math.PI * RADIUS;
    const DELAY = 5000;

    let timer = null;
    let startTime = 0;
    let elapsed = 0;
    let paused = false;

    progressCircle.style.strokeDasharray = CIRCUMFERENCE;
    progressCircle.style.strokeDashoffset = CIRCUMFERENCE;

    const swiper = new Swiper(swiperEl, {
      loop: true,
      allowTouchMove: false,
      autoplay: false,

      // ✅ Pagination
      pagination: paginationEl
        ? {
            el: paginationEl,
            clickable: true,
          }
        : undefined,

      // ✅ Navigation
      navigation: {
        nextEl: nextBtn,
        prevEl: prevBtn,
      },
    });

    function startProgress(fromPercent = 0) {
      clearTimeout(timer);

      const offset = CIRCUMFERENCE * (1 - fromPercent);
      const remaining = DELAY * (1 - fromPercent);

      progressCircle.style.transition = 'none';
      progressCircle.style.strokeDashoffset = offset;

      // force reflow
      progressCircle.getBoundingClientRect();

      progressCircle.style.transition =
        `stroke-dashoffset ${remaining}ms linear`;
      progressCircle.style.strokeDashoffset = 0;

      startTime = Date.now() - elapsed;

      timer = setTimeout(() => {
        if (!paused) swiper.slideNext();
      }, remaining);
    }

    function pause() {
      if (paused) return;
      paused = true;

      clearTimeout(timer);
      elapsed = Date.now() - startTime;

      const progress = Math.min(elapsed / DELAY, 1);
      progressCircle.style.transition = 'none';
      progressCircle.style.strokeDashoffset =
        CIRCUMFERENCE * (1 - progress);

      playBtn.classList.add('is-paused');
    }

    function resume() {
      if (!paused) return;
      paused = false;

      const progress = Math.min(elapsed / DELAY, 1);
      elapsed = progress * DELAY;

      startProgress(progress);
      playBtn.classList.remove('is-paused');
    }

    playBtn.addEventListener('click', () => {
      paused ? resume() : pause();
    });

    // ✅ restart progress on slide change (auto, arrows, pagination, swipe)
    swiper.on('slideChangeTransitionStart', () => {
      if (!paused) {
        elapsed = 0;
        startProgress(0);
      }
    });

    document.addEventListener('visibilitychange', () => {
        if (document.hidden) {
            // tab is hidden → pause safely
            pause();
        } else {
            // tab is visible again → resume
            resume();
        }
    });


    // INIT
    startProgress(0);
  });
});


//Sort action
document.addEventListener('click', (e) => {
  const label = e.target.closest('.facet-filters__label');
  if (!label) return;

  const field = label.closest('.facet-filters__field');
  if (!field) return;

  const radios = field.querySelector('.facet-filters__sort-radios');
  if (!radios) return;

  field.classList.toggle('is-open');
  radios.classList.toggle('is-open');
});

/* close when radio changes */
document.addEventListener('change', (e) => {
  if (!e.target.matches('input[name="sort_by"]')) return;

  const field = e.target.closest('.facet-filters__field');
  if (!field) return;

  field.classList.remove('is-open');

  const radios = field.querySelector('.facet-filters__sort-radios');
  if (radios) radios.classList.remove('is-open');
});




